import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="openas"
export default class extends Controller {
  connect() {
    $('#openas').select2();
  }
}
